import remainingChars from "surveylabJsAssets/page/_remaining-chars";

export default function () {
    $(function () {
        $('.checkbox-free-element').each(function () {
            initCheckboxFree($(this));
        });

        // On entering the free text field, select the corresponding checkbox
        $('.checkbox-free-element .free-text').on('focusin', function () {
            const $optionContainer = $(this).closest('.option-container');
            const $checkmark = $optionContainer.find($('.option-check'));
            $checkmark.prop("checked", true);
        });
    });
    remainingChars.initOnce();
}

function initCheckboxFree($wrapper: JQuery) {
    applyExclusiveItemRules($wrapper);

    $wrapper.find('.option-check').on('change', function (this: HTMLInputElement) {
        const checkboxID = $(this).attr('id');
        const textFieldID = '#' + checkboxID + '_free';
        const $checkbox = $(this);
        const $textField = $(textFieldID);

        $textField.val('');

        applyExclusiveItemRules($wrapper);

        if ($checkbox.is(':checked') && !$checkbox.prop('disabled')) {
            $textField.trigger('focus');
        }
    });
}

function applyExclusiveItemRules($wrapper: JQuery) {
    const $optionContainers = $wrapper.find('.option-container');
    const $exclusiveContainers = $optionContainers.filter(function () {
        return Number($(this).data('exclusive-item')) === 1;
    });
    const hasExclusiveSelection = $exclusiveContainers.find('.option-check:checked').length > 0;

    $optionContainers.each(function () {
        const $container = $(this);
        const isExclusive = Number($container.data('exclusive-item')) === 1;
        const $checkbox = $container.find('.option-check');
        const $freeText = $container.find('.free-text');

        if (hasExclusiveSelection && !isExclusive) {
            $checkbox.prop('checked', false);
            $checkbox.prop('disabled', true);
            $freeText.val('');
            $freeText.prop('disabled', true);
        } else {
            $checkbox.prop('disabled', false);
            $freeText.prop('disabled', false);
        }
    });
}
